import { Empty } from "components/ui"
import imgEmty from 'images/empty.svg'

export const Page404 = () => {
    return <Empty image={imgEmty} title='Данные отсутствуют' />
}